import { AbstractNode } from '@/orrm/model'

export default abstract class Wrapper<T extends AbstractNode> {
  model: T

  constructor (origin: T) {
    this.model = origin
  }
}
